"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedOptions = exports.ChartTypes = void 0;
exports.ChartTypes = [
    "area",
    "pie",
    "bar",
    "line",
    "stacked-bar",
    "100-stacked-bar",
    "column",
    "stacked-column",
    "100-stacked-column",
    "scatter",
    "bubble",
    "heatmap",
    "donut",
    "stacked-area",
    "100-stacked-area",
];
exports.NestedOptions = [
    "value",
    "is-completed",
    "start",
    "end",
    "due",
    "is-overdue",
    "hours",
    "first-name",
    "last-name",
    "city",
    "country",
];
